import axios from '@/libs/api.request'

export const getPDFList = (quoteId) => {
  return axios.request({
    url: `/quotes/${quoteId}/documents`,
    method: 'get'
  })
}

export const getSinglePDF = (quoteId, documentId) => {
  return axios.request({
    url: `/quotes/${quoteId}/documents/${documentId}`,
    method: 'get'
  })
}

export const createSinglePDF = (quoteId, data) => {
  return axios.request({
    url: `/quotes/${quoteId}/documents`,
    method: 'post',
    data
  })
}

export const updateSinglePDF = (quoteId, documentId, data) => {
  return axios.request({
    url: `/quotes/${quoteId}/documents/${documentId}`,
    method: 'put',
    data
  })
}

export const downloadQuotation = (quoteId, documentId) => {
  return axios.request({
    url: `/quotes/${quoteId}/documents/${documentId}/download`,
    method: 'get',
    responseType: 'blob'
  })
}
